import { render, staticRenderFns } from "./ClinicianPatientPDF.vue?vue&type=template&id=13a56332"
import script from "./ClinicianPatientPDF.vue?vue&type=script&lang=js"
export * from "./ClinicianPatientPDF.vue?vue&type=script&lang=js"
import style0 from "./ClinicianPatientPDF.vue?vue&type=style&index=0&id=13a56332&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports